'use strict'

import {trackEvent} from '../analytics/index'

export function attachMobileNavHandlers(select) {
  document.querySelector(`.dropdown__ui span`).innerHTML = document.querySelector('.wizard__nav .tab:first-child span').innerText

  select.addEventListener('blur', () => {
    addCards(select.options[select.options.selectedIndex].value)
  })
  select.addEventListener('change', () => {
    addCards(select.options[select.options.selectedIndex].value)
  })
}

export function attachNavHandlers(anchor) {
  anchor.addEventListener('click', e => {
    e.preventDefault()
    if (!anchor.classList.contains('tab--current')) {
      addCards(anchor.getAttribute('data-role'))
    }
  })
}

export function attachCardHandlers(card) {
  card.addEventListener('mouseenter', () => {
    card.classList.add('hover')
  })
  card.addEventListener('mouseleave', () => {
    card.classList.remove('hover')
  })
}

export function updateNav(role) {
  document.querySelector('.wizard__nav .tab--current').classList.remove('tab--current')
  document.querySelector(`.wizard__nav a[data-role='${role}']`).classList.add('tab--current')
  document.querySelector(`.dropdown__ui span`).innerHTML = document.querySelector(`.wizard__nav--dropdown select option[value="${role}"]`).innerText
  trackEvent('Wizard', 'Click', 'Role', role)
}

export function removeCards(callback) {
  const cards = document.querySelector('.wizard__cards--show')
  cards.classList.remove('wizard__cards--show')
  window.setTimeout(() => {
    cards.style.display = 'none'
    callback()
  }, 800)
}

function addCards(role) {
  const cards = document.querySelector(`.wizard__cards--${role}`)

  updateNav(role)
  removeCards(() => {
    cards.style.display = 'block'
    window.setTimeout(() => {
      cards.classList.add('wizard__cards--show')
    }, 100)
  })
}
